import React from 'react';
import { useIntl } from 'react-intl';
import css from './ListingPage.module.css';
import { Icons } from '../../components';
import { getMinBookingLabel } from '../../util/genericHelpers';
import { getListingAreaSqm, normalizeAreaSqmValue } from '../../util/listingArea';

const isRateAvailable = value => {
  return typeof value === 'string' ? value !== '-' : Boolean(value);
};

const BookingDetails = ({ minimumHours, maxPeople, area, publicData, listing, bookingType }) => {
  const intl = useIntl();
  const publicDataAreaSqm = getListingAreaSqm(publicData);
  const listingAreaSqm = getListingAreaSqm(listing);
  const areaSqm =
    publicDataAreaSqm !== null
      ? publicDataAreaSqm
      : listingAreaSqm !== null
      ? listingAreaSqm
      : normalizeAreaSqmValue(area);
  const hasAreaSqm = areaSqm !== null;

  return (
    <div className={css.bookingDetails}>
      {/* Min. Booking Period */}
      <div className={css.bookingInfoBlock}>
        <Icons name="clock" />
        <div className={css.bookingInfo}>
          <p>
            {intl.formatMessage({
              id: 'BookingInfo.minBookingPeriod',
              defaultMessage: 'Min. booking period',
            })}
          </p>
          <p>{getMinBookingLabel(intl, minimumHours, bookingType)}</p>
        </div>
      </div>

      {/* Cast & Crew size */}
      <div className={css.bookingInfoBlock}>
        <Icons name="crewSize" />
        <div className={css.bookingInfo}>
          <p>
            {intl.formatMessage({
              id: 'BookingInfo.castCrewSize',
              defaultMessage: 'Cast & Crew size',
            })}
          </p>
          <p>
            {maxPeople}{' '}
            {intl.formatMessage({
              id: 'BookingInfo.people',
              defaultMessage: 'people',
            })}
          </p>
        </div>
      </div>

      {/* Area */}
      <div className={css.bookingInfoBlock}>
        <Icons name="area" />
        <div className={css.bookingInfo}>
          <p>
            {intl.formatMessage({
              id: 'BookingInfo.areaSqFt',
              defaultMessage: 'Area in Sqm',
            })}
          </p>

          {hasAreaSqm ? (
            <p>
              {intl.formatMessage(
                {
                  id: 'BookingInfo.fixedArea',
                  defaultMessage: '{area} Sqm',
                },
                {
                  area: intl.formatNumber(areaSqm),
                }
              )}
            </p>
          ) : (
            <p>N/A</p>
          )}
        </div>
      </div>

    </div>
  );
};

export default BookingDetails;
